import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const UploadDialogueWrapper = styled.div`
  width: 100%;
  padding-top: 20px;
  height: 91%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Title = styled.div`
  width: 100%;
  font-size: 20px;
  padding-left: 20px;
  margin-left: 20px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const UploadDialogueContent = styled.div`
  padding-top: 20px;
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const DropZone = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  height: 100%;
  text-align: center;
  margin-left: 20px;
  border: 1px dashed rgba(140, 140, 140, 0.8);
  border-radius: 3px;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 300px;
  width: 96%;
`

export const InnerDropZone = styled.div`
  width: 97%;
  height: 280px;
  background-color: rgba(0, 0, 0, 0.05);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 20px;
`

export const UploadDialogueForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-right: 20px;
  padding-left: 10px;
  width: 96.5%;
`

export const FormButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 10px;
  margin-top: 20px;
`

export const Label = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  width: 100%;
  font-size: 16px;
`

export const FormElementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  width: 100%;
`

export const FileName = styled.span`
  font-style: italic;
  margin-top: 16px;
  font-weight: bolder;
`

export const LoadingHeadersMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
`

export const HeaderListing = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 20px;
  margin-bottom: 20px;
  font-size: 14px;
`

export const DateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: baseline;
  padding-left: 20px;
  padding-right: 30px;
`

export const DateItems = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: baseline;
`

export const SubTitle = styled.div`
  font-size: 14px;
  padding-left: 20px;
  margin-left: 20px;
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 10px;
  width: 100%;
`